import * as React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateTo } from '../../../../actions/navigationActions';
import { loadAllAddresses, createQuoteFromPolicy, initiateHomeContentSteps, setStep } from '../../../../actions/salesActions';
import { refreshCart } from '../../../../actions/cartActions';
import { BUILDING_AND_CONTENT_JOURNEY_BUILDER, DASHBOARD } from '../../../../routes/routes';
import KPBreadCrumb from '../../../KPBreadCrumb/KPBreadCrumb';
import FAQItem from '../../../FAQ/FAQItem';
import '../GetBuilding/GetBuilding.css';
import './GetHomeContent.css';
import { logEvent } from '../../../../firebase/firebase';

class GetHomeContent extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loggedIn: this.props.auth.uid ? true : false,
        }

        this.handleGetQuote = this.handleGetQuote.bind(this);
    }

    componentWillMount() {
        logEvent('SSP_get_home_content_landed', 'user_landed_on_get_home_content');
    }

    async handleGetQuote() {
        logEvent('SSP_get_home_content_add_to_quote', 'user_cliked_get_a_quote_home_content');
        let nextPage = BUILDING_AND_CONTENT_JOURNEY_BUILDER;
        if (this.props.profile.policyId === "" && this.props.sales.quoteId === "") {
            await this.props.dispatchAction(initiateHomeContentSteps());
            await this.props.dispatchAction(navigateTo(nextPage));
        }
        else {
            let hasAddress = (await this.props.dispatchAction(loadAllAddresses()))?.length > 0;
            if (this.props.profile.policyId !== "" && this.props.sales.quoteId === "") {
                await this.props.dispatchAction(createQuoteFromPolicy());
                if (this.props.sales.quoteId !== "") {
                    await this.props.dispatchAction(refreshCart());
                }
            }
            if (this.props.sales.quoteId !== "") {
                await this.props.dispatchAction(initiateHomeContentSteps());
                await this.props.dispatchAction(setStep(3, (hasAddress ? 1 : 2)));
                await this.props.dispatchAction(navigateTo(nextPage));
            }
        }
    }

    public render() {

        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]
        let faqSet = [{
            header: "What is home contents insurance?",
            body: "<p class='mb-0'>Simply put, home contents insurance covers loss of, or damage to, items in your home, which belong to you or to any members of your household who live with you, but not including tenants.</p>",
            id: 1
        },
        {
            header: "What's covered by home contents insurance?",
            body: "<p class='mb-0'>Home contents insurance covers a range of possessions that you keep in your home. We say that if you take the roof off your home and turn it upside down, then what falls out = your home contents. For example, your furniture, fridge, clothes, and kitchen appliances. If it ain’t nailed down, it’s usually covered by this policy.</p>",
            id: 2
        },
        {
            header: "Insure your home contents for what it’s worth.",
            body: "<p class='mb-0'>The insured value noted on your policy schedule is the maximum amount that we’ll pay for any of your home contents insurance-related claims, less the excess amounts payable by you, and less any dual and under-insurance. You need to insure your contents for their total replacement value, meaning the cost of replacing the items that you’re claiming for with new items.If you insure the contents for an amount less than their replacement value, we’ll then pay you proportionately.</p>",
            id: 3
        },
        {
            header: "How does home contents insurance work?",
            body: "<p class='mb-0'>Home contents insurance works by paying out an amount to replace your stolen or damaged valuables. Before you get the cash, the excess is deducted, as well as any under-insurance. As an example, if you insure your contents for R200,000 but their actual value is double this amount, and you claim R5,000 for a stolen TV, we'll pay out half of what you claim.</p>",
            id: 4
        },
        {
            header: "What does home contents insurance cover?",
            body: "<p class='mb-0'>We have 2 home contents insurance options available: Comprehensive; and fire and fury. Here’s what each option covers:<br/><br /><b>Comprehensive</b><br/> <br />With comprehensive home contents insurance you’re covered for the loss of, or damage to, items in your home, which belong to you or to any members of your household who live with you, but not including tenants.<br/><br/><b>Fire and fury</b><br/><br/>With this home contents insurance option, you’re covered for the loss of, or damage to, items in your home, which belong to you or to any members of your household who live with you, but not including tenants, and except if this loss or damage is the result of theft or attempted theft. So, fire? Covered.Storm damage? Covered.Robbery ? Afraid not.<br/><br/>For more info on what’s covered by the king, click <a href='/Content/documents/King-price-insurance-policy.pdf' target='_blank'><b><u>here.</b></u></a></p>",
            id: 5
        },
        {
            header: "What's NOT covered by home contents insurance?",
            body: `<p class='mb-0'>Home contents insurance doesn’t cover things like:<ul> 
                    <li> Bicycles.</li> 
                    <li> Contact lenses and prescription glasses.</li>
                    <li> Cellphones.</li>
                    <li> Hearing aids.</li>
                    <li> Drones (there’s also no cover for loss or damage while being used).</li>
                    </ul>
                    For more info on what’s covered by the king, click <a href='/Content/documents/King-price-insurance-policy.pdf' target='_blank'><b><u>here.</b></u></a></p>`,
            id: 6
        },
        {
            header: "Can you claim for termite damage under home contents insurance?",
            body: "<p class='mb-0'>Damage that's caused by insects or pests, like termites, moths, or rats isn't covered by the king's home contents insurance.</p>",
            id: 7
        }];

        let faq;
        if (faqSet) {
            faq = faqSet.map((item) => {
                if (item.header !== "") {
                    return <FAQItem className="mb-12px" header={item.header} body={item.body} keyId={item.id} activeKey={this.state.accordionActiveKey} />
                }
            });
        }

        return (
            <div className={"building-and-home " + (this.state.loggedIn ? "logged-in" : "logged-out")}>
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Get home content insurance" />

                <div className="building-and-home-red-banner">
                    <div className="row">
                        <div className="col-md-3 align-center sm-align-left">
                            <img src="./Images/OnlineQuotation/BuildingAndHomeContent/home-content-landing-banner-image.svg" alt="Home Content Insurance" title="Home Content Insurance" />
                        </div>

                        <div className="col-md-5 col-lg-6">
                            <div className="building-and-home-red-banner-heading">
                                Home contents insurance
                            </div>
                            <div className="mt-2">
                                If you turn your home upside down, we’ll insure everything that falls out
                            </div>
                        </div>

                        <div className="col-md-4 col-lg-3 building-and-home-red-banner-get-quote align-center">
                            <button className="btn btn-solid-green btn-responsive" onClick={this.handleGetQuote}>Get a quote</button>
                        </div>
                    </div>
                </div>

                <div className="building-and-home-sub-panel">
                    <div className="building-and-home-sub-panel-heading">
                        In a nutshell
                    </div>
                    <div className="building-and-home-sub-panel-body">
                        Imagine turning your house upside down... Everything that would fall out, should be included under your home contents insurance cover. It’s that simple! So, from TVs and microwaves, to shoes and sheets, to your collection of CDs… We offer comprehensive home contents cover, competitive premiums, and royal service. We’ve got the full house!
                    </div>  
                </div>

                <div className="row noma">
                    <div className="col-md-6 nopa">
                        <div className="pt-4 building-and-home-sub-panel">
                            <div className="building-and-home-sub-panel-heading">
                                Choose your cover
                            </div>
                            <div className="pt-4 row">
                                <div className="col-3 col-md-2 pr-0 align-center">
                                    <img className="get-home-content-cover-image" src="./Images/OnlineQuotation/BuildingAndHomeContent/building-content-landing-umbrella.svg" alt="Umbrella" title="Umbrella" />
                                </div>
                                <div className="col-9 col-md-10">
                                    <div className="get-home-content-sub-heading">
                                        Comprehensive
                                    </div>
                                    <div className="building-landing-sub-banner-body pt-2">
                                        With comprehensive home contents insurance you’re covered for the loss of, or damage to, items in your home, which belong to you or to any members of your household who live with you, but not including tenants.
                                    </div>
                                </div>
                            </div>

                            <div className="get-home-content-cover-hr mt-15px mb-15px"></div>

                            <div className="row">
                                <div className="col-3 col-md-2 pr-0 align-center">
                                    <img className="get-home-content-cover-image" src="./Images/OnlineQuotation/BuildingAndHomeContent/building-content-landing-house-fire.svg" alt="Fire" title="Fire and Fure" />
                                </div>
                                <div className="col-9 col-md-10">
                                    <div className="get-home-content-sub-heading">
                                        Fire and fury
                                    </div>
                                    <div className="building-landing-sub-banner-body pt-2">
                                        With this home contents insurance option, you’re covered for the loss of, or damage to, items in your home, which belong to you and the people who live with you, except if this loss or damage is the result of theft or attempted theft.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 nopa">
                        <Card className="building-and-home-sub-panel pt-4">
                            <div className="building-and-home-sub-panel-heading">
                                FAQs
                            </div>
                            <div className="new-ssp-code-red-faq-block code-red-accordion-holder">
                                <Accordion className="" onSelect={(e) => this.setState({ accordionActiveKey: Number(e) })}>
                                    {faq}
                                </Accordion>
                            </div>
                        </Card>
                    </div>
                </div>
                <div className="row d-md-none">
                    <div className="col btn-solid-green footer-button justify-content-center" onClick={this.handleGetQuote}>
                        Get a quote
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile,
        auth: state.firebase.auth,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GetHomeContent);